import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { Label } from 'core/components/label';
import { BasisTheoryText } from 'core/components/basis-theory';
import { useBasisTheoryElementRefs } from 'common/hooks/basis-theory-elements.context';
import { useCallRecordingPause } from 'common/hooks/use-call-recording-pause';
import useStyles from './ach-field.styles';

const ACHFields = ({ mode }) => {
  const classes = useStyles();
  const labelType = mode === 'dark' ? 'formLabel' : 'formLabelLight';
  const { setFieldValue } = useFormikContext();
  const { routingNumberRef, accountNumberRef, accountHolderNameRef } = useBasisTheoryElementRefs();

  // Pause Dialpad recording while full routing/account numbers are on screen (internal agents).
  useCallRecordingPause();

  const handleRoutingNumberChange = (event) => {
    const isRoutingNumberValid = event.complete && event.valid;
    setFieldValue('isRoutingNumberValid', isRoutingNumberValid);
  };

  const handleAccountNumberChange = (event) => {
    const isAccountNumberValid = event.complete && event.valid;
    setFieldValue('isAccountNumberValid', isAccountNumberValid);
  };

  const handleAccountHolderNameChange = (event) => {
    const isAccountHolderNameValid = event.complete && event.valid;
    setFieldValue('isAccountHolderNameValid', isAccountHolderNameValid);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} className={classes.row}>
        <Label type={labelType}>Account Holder Name</Label>
        <BasisTheoryText
          id="accountHolderName"
          ref={accountHolderNameRef}
          placeholder="Account Holder Name"
          mode={mode}
          validation={/.+/} // at least 1 character
          onChange={handleAccountHolderNameChange}
        />
      </Grid>
      <Grid item xs={6} className={classes.row}>
        <Label type={labelType}>Routing Number</Label>
        <BasisTheoryText
          id="routingNumber"
          ref={routingNumberRef}
          placeholder="Routing Number"
          mode={mode}
          validation={/^\d{9}$/} // enforce 9 digits
          onChange={handleRoutingNumberChange}
        />
      </Grid>
      <Grid item xs={6} className={classes.row}>
        <Label type={labelType}>Account Number</Label>
        <BasisTheoryText
          id="accountNumber"
          ref={accountNumberRef}
          placeholder="Account Number"
          mode={mode}
          validation={/^\d+$/} // enforce only digits
          onChange={handleAccountNumberChange}
        />
      </Grid>
    </Grid>
  );
};

ACHFields.defaultProps = {
  mode: 'light'
};

ACHFields.propTypes = {
  mode: PropTypes.oneOf(['light', 'dark'])
};

export default ACHFields;
